import { DeepPartial, AppConfig } from "../../../../src/app/interfaces/app-config";

export const projectConfig: DeepPartial<AppConfig> = {
    // Ejemplo
     pages: {
         login: {
             title: 'Iniciar sesión',
         },
         location: {
            titlePlural: 'Predios',
            titleSingular: 'Predio',
            form: {
                name: {
                    label: 'Nombre',
                    placeholder: 'Ingresa tu nombre completo'
                },
                address: {
                    label: 'Dirección',
                    placeholder: 'Ingresa dirección'
                },
                zona: {
                    label: 'Zona',
                    placeholder: 'Ingresa tu zona'
                },
                city: {
                    label: 'Ciudad',
                    placeholder: 'Selecciona...'
                },
                country: {
                    label: 'País',
                    placeholder: 'Selecciona...'
                },
                latitude: {
                    label: 'Latitud',
                    placeholder: 'Selecciona...'
                },
                longitude: {
                    label: 'Longitud',
                    placeholder: 'Selecciona...'
                },
            },
            form_sector: {
                name: {
                    label: 'Nombres del sector',
                    placeholder: 'Ingresa nombre'
                },
                image: {
                    label: 'Imagen del sector',
                    placeholder: 'Imagen del sector'
                },
                description: {
                    label: 'Descripción',
                    placeholder: 'Descripción...'
                },
                cant: {
                    label: 'Imagen del sector',
                    placeholder: 'Imagen del sector'
                },
                doors: {
                    label: 'Imagen del sector',
                    placeholder: 'Imagen del sector'
                },
                status: {
                    label: 'Imagen del sector',
                    placeholder: 'Imagen del sector'
                },
                code: {
                    label: 'Numero asiento',
                    placeholder: '0000'
                },
            }
        },
        profile: {
            titlePlural: 'Registros',
            titleSingular: 'Registro',
            form: {}
        },



        events: {
            titlePlural: 'Eventos',
            titleSingular: 'Evento',
            form: {
                name: {
                    label: 'Nombre del evento',
                    placeholder: 'Ingresa tu nombre del evento'
                },
                slug: {
                    label: 'Slug del evento',
                    placeholder: 'Ej: slug-evento-evento...'
                },
                subName: {
                    label: 'Sub nombre',
                    placeholder: 'Ingrese sub nombre...'
                },
                description: {
                    label: 'Descripción del evento',
                    placeholder: 'Describir...'
                },
                files: {
                    label: 'Subir image del evento(Vertical)',
                    placeholder: 'Seleccionar imagen'
                },
                image: {
                    label: 'Subir image del evento(Horizontal)',
                    placeholder: 'Seleccionar imagen'
                },
                view: {
                    label: 'Tipo de vista',
                    placeholder: 'Seleccionar...'
                },
                category: {
                    label: 'Categoria',
                    placeholder: 'Selecciona...'
                },
                stage: {
                    label: 'Predio',
                    placeholder: 'Selecciona...'
                },
                keylibelula: {
                    label: 'Api Key Libelula',
                    placeholder: 'Escribir...'
                },
                keycashier: {
                    label: 'Llave caja Libelula',
                    placeholder: 'Escribir...'
                },
                keyService: {
                    label: 'Api Key de servicio',
                    placeholder: 'Escribir...'
                },
                keycashierService: {
                    label: 'Llave caja de servicio',
                    placeholder: 'Escribir...'
                },
                date: {
                    label: 'Fecha del evento',
                    placeholder: '00/00/0000'
                },
                time: {
                    label: 'Hora del evento',
                    placeholder: '00:00'
                },
                user: {
                    label: 'Usuarios(selección multiple)',
                    placeholder: 'Seleccionar...'
                },
                agency: {
                    label: 'Agencia',
                    placeholder: 'Seleccionar...'
                },
                credencial1: {
                    label: 'Credencial web',
                    placeholder: 'Seleccionar...'
                },
                credencial2: {
                    label: 'Credencial caja',
                    placeholder: 'Seleccionar...'
                },
                credencial3: {
                    label: 'Credencial factura',
                    placeholder: 'Seleccionar...'
                },
                pixelId: {
                    label: 'ID pixel',
                    placeholder: 'Escribir...'
                },
                pixelTokent: {
                    label: 'Token pixel',
                    placeholder: 'Escribir...'
                },
            }
        },
        eventsBilling: {
            titlePlural: 'Eventos',
            titleSingular: 'Evento',
            form: {
                companyName: {
                    label: 'Razón social',
                    placeholder: 'Razón social'
                },
                name: {
                    label: 'Razón social',
                    placeholder: 'Escribir razón social...'
                },
                pointSale: {
                    label: 'Punto de venta',
                    placeholder: 'Escribir punto de venta...'
                },
                address: {
                    label: 'Dirección',
                    placeholder: 'Dirección'
                },
                address2: {
                    label: 'Segunda dirección',
                    placeholder: 'Escribir segunda dirección...'
                },
                city: {
                    label: 'Ciudad',
                    placeholder: 'Seleccionar ciudad...'
                },
                title: {
                    label: 'Título',
                    placeholder: 'Escribir título...'
                },
                office: {
                    label: 'Sucursal',
                    placeholder: 'Escribir sucusal...'
                },
                phone: {
                    label: 'Teléfono',
                    placeholder: 'Escribir teléfono...'
                },
                nit: {
                    label: 'Nit',
                    placeholder: 'Escribir nit...'
                },
                type: {
                    label: 'Tipo de factura',
                    placeholder: 'Escribir tipo de factura...'
                },

            }
        },
        eventsServiceFree: {
            titlePlural: 'Eventos',
            titleSingular: 'Evento',
            form: {
                companyName: {
                    label: 'Razón social',
                    placeholder: 'Razón social'
                },
                name: {
                    label: 'Nombre de la sucursal',
                    placeholder: 'Nombre de la sucursal'
                },
                pointSale: {
                    label: 'Nombre punto de venta',
                    placeholder: 'Nombre punto de venta'
                },
                address: {
                    label: 'Dirección',
                    placeholder: 'Dirección'
                },
                city: {
                    label: 'Ciudad',
                    placeholder: 'Seleccionar ciudad...'
                },
                phone: {
                    label: 'Teléfono',
                    placeholder: 'Teléfono'
                },
            }
        },
        eventsPlaform: {
            titlePlural: 'Eventos',
            titleSingular: 'Evento',
            form: {
                companyName: {
                    label: 'Razón social',
                    placeholder: 'Razón social'
                },
                name: {
                    label: 'Nombre de la sucursal',
                    placeholder: 'Nombre de la sucursal'
                },
                pointSale: {
                    label: 'Nombre punto de venta',
                    placeholder: 'Nombre punto de venta'
                },
            }
        },
        tickets: {
            titlePlural: 'Entradas',
            titleSingular: 'Entrada',
            form:{
                name: {
                    label: 'Nombre del ticket',
                    placeholder: 'Nombre del ticket...'
                },
                status: {
                    label: 'Activar',
                    placeholder: 'Activar...'
                },
                number : {
                    label: 'Numero de ticket',
                    placeholder: 'Numero de ticket...'
                },
                size : {
                    label: 'Tamaño de la entrada',
                    placeholder: 'Tamaño de la entrada...'
                },
            },
        },


        mailing: {
            titlePlural: 'Notificaciones',
            titleSingular: 'Notificación',
            form:{
                name: {
                    label: 'Titulo de la notificación',
                    placeholder: 'Titulo de la notificación...'
                },
                responsible: {
                    label: 'Responsable',
                    placeholder: 'Responsable...'
                },
                description: {
                    label: 'Descripción',
                    placeholder: 'Descripción...'
                },
                date: {
                    label: 'Programar fecha y hora',
                    placeholder: 'Programar fecha y hora...'
                },
                nameAdmin: {
                    label: 'Adminnistadores',
                    placeholder: 'Adminnistadores...'
                },
                nameSubAdmin: {
                    label: 'Sub Adminnistadores',
                    placeholder: 'Sub Adminnistadores...'
                },
                user: {
                    label: 'Usuarios',
                    placeholder: 'Usuarios...'
                },
                city: {
                    label: 'Ciudad',
                    placeholder: 'Ciudad...'
                },
                zone: {
                    label: 'Zona',
                    placeholder: 'Zona...'
                },
                location: {
                    label: 'Ubicación',
                    placeholder: 'Ubicación...'
                },
                companyName: {
                    label: 'Empresa',
                    placeholder: 'Empresa...'
                },
                branchName: {
                    label: 'Sucursal',
                    placeholder: 'Sucursal...'
                },
            },
        },
        historyTickets: {
            titlePlural: 'Reportes de entradas',
            titleSingular: 'Reporte de entrada',
            form:{},
            form_filter: {
                search: {
                    label: 'Buscar código',
                    placeholder: 'Escribir código...'
                },
                name:{
                    label: 'Nombre',
                    placeholder: 'Escribir nombre...'
                },
                lastName:{
                    label: 'Apellido',
                    placeholder: 'Escribir apellido...'
                },
                email:{
                    label: 'Correo electrónico',
                    placeholder: 'Escribir correo electrónico...'
                },
                numberCi:{
                    label: 'Numero de carnet',
                    placeholder: 'Escribir numero de carnet...'
                },
                initial_date:{
                    label: 'Fecha inicio',
                    placeholder: 'Escribir fecha inicio...'
                },
                end_date:{
                    label: 'Fecha fin',
                    placeholder: 'Escribir fecha fin...'
                },
                event:{
                    label: 'Eventos',
                    placeholder: 'Seleccionar evento...'
                },
            }
        },

        sendMail: {
            titlePlural: 'Correos enviados',
            titleSingular: 'Correo enviado',
            form:{},
            form_filter: {
                type: {
                    label: 'Tipo de notificación',
                    placeholder: 'Seleccionar...'
                },
                status:{
                    label: 'Estado',
                    placeholder: 'Seleccionar...'
                },
            }
        },
        exihibition: {
            titlePlural: 'Exhibiciones',
            titleSingular: 'Exhibición',
            form:{},
        },

        types: {
            titlePlural: 'Tipos de Eventos',
            titleSingular: 'Tipo de Evento',
            form:{
                name:{
                    label: 'Nombre',
                    placeholder: 'Escribir nombre...'
                },
                title:{
                    label: 'Titulo',
                    placeholder: 'Escribir titulo...'
                },
                status:{
                    label: 'Estado',
                    placeholder: 'Escribir estado...'
                },
            },
        },
        access: {
          titlePlural: 'Accesos',
          titleSingular: 'Acceso',
          form:{
            nfc:{
              label: 'Codigo NFC1',
              placeholder: 'Escribir codigo AA...'
            },
            nfc2:{
              label: 'Codigo NFC 2',
              placeholder: 'Escribir codigo BB...'
            },
            online:{
              label: 'Online',
              placeholder: 'Escribir codigo AA...'
            },
            date:{
              label: 'Fecha',
              placeholder: 'Escribir...'
            },
            time:{
              label: 'Hora',
              placeholder: 'Escribir...'
            },
            exhibitions:{
              label: 'Exhibiciones(selección multiple)',
              placeholder: 'Seccionar...'
            },
            all:{
              label: 'Habilitar todas las Exhibiciones',
              placeholder: 'Escribir...'
            },
            readNfc:{
              label: 'Lectura con Nfc',
              placeholder: 'Escribir...'
            },
            qr:{
              label: 'Lectura con Qr',
              placeholder: 'Escribir...'
            },
            active:{
              label: 'Activar',
              placeholder: 'Escribir...'
            },
          },
      },
     },

    menu: [
        {
            headTitle1: "General",
            permissions: 'default'
        },
        {
            id: 1,
            level: 1,
            path: '/account',
            title: "Administrar Organizaciones",
            icon: "home",
            type: "link-external-admin",
            permissions: 'default'
        },
        {
            id: 1,
            level: 1,
            path: '/dashboard',
            title: "Dashboard",
            icon: "home",
            type: "link",
            permissions: 'tickets-page-dashboard'
        },
        /* {
            headTitle1: "Admin",
        },
        {
            id: 2,
            level: 1,
            path: '/users',
            title: "Usuarios del admin",
            icon: "bookmark",
            type: "link",
        },
        {
            id: 3,
            level: 1,
            path: '/profile',
            title: "Registrados",
            icon: "bookmark",
            type: "link",
        }, */


        {
            headTitle1: "Predios",
            permissions: 'default'
        },
        {
            id: 2,
            level: 1,
            path: '/location/create',
            title: "Crear predios",
            icon: "bookmark",
            type: "link",
            permissions: 'tickets-page-stage'
        },
        {
            id: 3,
            level: 1,
            path: '/location',
            title: "Predios habilitados",
            icon: "bookmark",
            type: "link",
            permissions: 'tickets-page-stage_false'
        },
        {
            id: 4,
            level: 1,
            path: '/location/list-archived',
            title: "Predios archivados",
            icon: "bookmark",
            type: "link",
            permissions: 'tickets-page-stage_false'
        },
        {
            headTitle1: "Eventos",
            permissions: 'default'
        },
        {
            id: 4,
            level: 1,
            path: 'event/list-category',
            title: "Categorias",
            icon: "bookmark",
            type: "link",
            permissions: 'tickets-page-category'
        },
        {
            id: 4,
            level: 1,
            path: '/event',
            title: "Eventos actuales",
            icon: "bookmark",
            type: "link",
            permissions: 'tickets-page-event'
        },
        {
            id: 4,
            level: 1,
            path: '/types',
            title: "Tipos",
            icon: "bookmark",
            type: "link",
            permissions: 'tickets-page-type'
        },

        {
            headTitle1: "Promociones",
            permissions: 'admin-page-promotions'
        },
        {
            id: 4,
            level: 1,
            path: '/promotions',
            title: "Promociones",
            icon: "bookmark",
            type: "link",
            permissions: 'admin-page-promotions'
        },

        {
          headTitle1: "Tickets",
          permissions:'default',
        },
        {
          id: 5,
          level: 1,
          path: 'history-tickets', // history-tickets - report-tickets
          title: "Reportes de entradas",
          icon: "bookmark",
          type: "link",
          permissions:'organization-page-history_tickets',
        },
        {
          id: 5,
          level: 1,
          path: 'report-tickets', // history-tickets - report-tickets
          title: "Reportes de entradas",
          icon: "bookmark",
          type: "link",
          permissions:'tickets-page-report',
        },
        {
          id: 5,
          level: 1,
          path: 'assistance',
          title: "Reporte de asistencia",
          icon: "bookmark",
          type: "link",
          permissions:'organization-page-assistance',
        },

    ],


    horizontalMenu: [
      {
          id: 1,
          level: 1,
          path: '/dashboard',
          title: "Dashboard",
          icon: "home",
          type: "link",
          permissions:'tickets-page-dashboard',
      },
    ]
};
